import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadImageComponent } from 'src/app/dashboard/upload-image/upload-image.component';
@Component({
  selector: 'media-selector',
  templateUrl: './media-selector.component.html',
  styleUrls: ['./media-selector.component.scss']
})
export class MediaSelectorComponent implements OnInit {

  @Input() imgURL: string = undefined;
  @Input() mediaID: string | number = undefined;
  @Input() showClearButton: boolean = false;

  // Optional validation rules — forwarded to the underlying upload modal.
  @Input() maxWidth?: number;
  @Input() maxHeight?: number;
  @Input() minWidth?: number;
  @Input() minHeight?: number;
  @Input() maxBytes?: number;

  @Output() imgURLChange: EventEmitter<any> = new EventEmitter();
  @Output() mediaIDChange: EventEmitter<any> = new EventEmitter();

  @Output() mediaChanged: EventEmitter<any> = new EventEmitter();

  constructor(
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void { }

  openUploader() {
    const modalRef = this.modalService.open(UploadImageComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.id = 10;
    // Forward optional validation rules.
    modalRef.componentInstance.maxWidth = this.maxWidth;
    modalRef.componentInstance.maxHeight = this.maxHeight;
    modalRef.componentInstance.minWidth = this.minWidth;
    modalRef.componentInstance.minHeight = this.minHeight;
    modalRef.componentInstance.maxBytes = this.maxBytes;
    modalRef.result.then((result) => {
      //console.log(result);
      if (result != 'Modal Closed') {

        this.imgURL = result[0];
        this.mediaID = result[1];

        this.imgURLChange.emit(result[0])
        this.mediaIDChange.emit(result[1])

        this.mediaChanged.emit({
          url: result[0],
          mediaId: result[1]
        })

      }
    }).catch((error) => {
      console.log(error);
    });
  }

  clearSelected() {
    this.imgURL = '';
    this.mediaID = '';

    this.imgURLChange.emit('')
    this.mediaIDChange.emit('')

    this.mediaChanged.emit({
      url: '',
      mediaId: ''
    })
  }



}
